<ion-header no-border>
  <ion-toolbar mode="ios">
    <ion-title color="primary"> {{ eventData.listingAddress }} </ion-title>
    <ion-button
      class="slim-close-button"
      mode="md"
      (click)="close()"
      slot="start"
      fill="clear"
    >
      <ion-icon name="close-outline" />
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="container">
    <div class="item-detail">
      <ion-icon name="person-outline" />
      <ion-label *ngIf="isEventFree">Not assigned</ion-label>
      <ion-label *ngIf="!isEventFree">
        <ion-chip>
          <avatar
            class="avatar"
            [imageURL]="eventData.agentImageURL"
            [avatarName]="eventData.agentAvatarName"
          />
          <ion-label>{{ eventData.agent.username }}</ion-label>
        </ion-chip>
      </ion-label>
    </div>

    <div class="item-detail">
      <ion-icon name="location-outline" />
      <ion-label>{{ eventData.listingAddress }}</ion-label>
    </div>

    <div class="item-detail">
      <ion-icon name="time-outline" />
      <ion-label>{{ eventData.formattedShortDate }}</ion-label>
    </div>

    @let isAssigned = eventData.status === OpenHouseEventStatus.assigned;
    @let notes = eventData.internalNote;

    @if (isAssigned && notes) {
      <div class="item-note">
        <div class="label">Admin note</div>
        <!-- If the notes are too long we display them in a new line -->
        <div class="notes" [class.full-width]="notes.length > 40">{{ notes }}</div>
      </div>
    }

    <div
      class="btns"
      *ngIf="isEventPending && eventData.status !== OpenHouseEventStatus.assigned"
    >
      <ion-button
        [disabled]="eventData.didAgentRequestEvent"
        (click)="requestEvent()"
        >{{ eventData.didAgentRequestEvent ? 'Requested' : 'Request' }}</ion-button
      >
    </div>
  </div>
</ion-content>
